import { render, staticRenderFns } from "./orgpoint.vue?vue&type=template&id=7dbd63f6&scoped=true"
import script from "./orgpoint.vue?vue&type=script&lang=js"
export * from "./orgpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbd63f6",
  null
  
)

export default component.exports